<template>
  <div class="header-btns-wrap">
    <p class="btn header-btn header-btn--userInfo">
      <span> {{ this.userInfo.username }} </span>
    </p>
    <div class="header-btn__spacer"></div>
    <a class="btn btn--red header-btn header-btn--logout" @click="logout">
      <span>logout</span>
    </a>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
  name: "HeaderBtns",
  components: {},
  data() {
		return {
		
		selected: '',
		};
  },
  props: {
	userInfo: {}
  },
  mounted() {
		
	},
  methods: {
    logout() {
      this.$store.dispatch("clearAll");
      this.$store.dispatch("authLogout");
      this.$router.push("/");
    },
	
  }
});
</script>

<style lang="scss" scoped>
.header-btns-wrap {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 3px 0;

  @media only screen and (max-width: 1150px) {
    flex-direction: column;
  }

  @media only screen and (min-width: 1150px) {
    align-items: flex-start;
    padding-top: 15px;
  }
}

.header-btn {
  letter-spacing: 1.05px;
  font-weight: 600;
  font-size: 12px;

  padding-left: 10px;
  padding-right: 30px;
  border-radius: 5px;

  background-position: calc(100% - 6px) center;
  background-repeat: no-repeat;
  background-size: 19px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding-bottom: 1px;
  height: 25px;

  &--logout {
    background-image: url("../../assets/logout.svg");
    height: 32px;
  }

  &--userInfo {
    border: 3px solid $color5;
    background-image: url("../../assets/user.svg");
    cursor: default;
  }

  &__spacer {
    display: block;
    width: 20px;
    height: 5px;
  }
}
</style>